<template>
  <div id="app">
    <notifications></notifications>
    <router-view/>
  </div>
</template>
<script>
export default {
  mounted() {
    if (window.localStorage.getItem('northswing-token') !== null
      && window.localStorage.getItem('northswing-user') !== null) {
      this.$store.commit('setAuthToken', window.localStorage.getItem('northswing-token'));
      this.$store.commit('setUser', JSON.parse(window.localStorage.getItem('northswing-user')));
    }
    this.$store.dispatch('getDefaultAvatars');
  },
};
</script>
